
export default function Profile() {
  return (
    <section id="profile" className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
          代表プロフィール
        </h2>

        <div className="bg-gradient-to-br from-cyan-50 to-white rounded-2xl p-8 shadow-lg">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            {/* Profile Image */}
            <div className="flex-shrink-0 mx-auto md:mx-0">
              <div className="w-48 h-48 rounded-lg overflow-hidden border-4 border-cyan-500 shadow-lg bg-white">
                <img
                  src="https://static.readdy.ai/image/6095022e0c468d9535f3b012298ccfc9/02256f69eb8aad88a819ab929130d5be.png"
                  alt="代表者"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Profile Info */}
            <div className="flex-1">
              <div className="mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2 text-left">代表 下向井 恭兵</h3>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-cyan-100 text-cyan-800 text-sm font-normal px-3 py-1 rounded-full">
                    江田島商工会 会員
                  </span>
                  <span className="bg-cyan-100 text-cyan-800 text-sm font-normal px-3 py-1 rounded-full">
                    日本エアコンクリーニング協会 個人会員
                  </span>
                </div>
              </div>

              <div className="space-y-4 text-gray-700 font-normal leading-relaxed text-left">
                <p>
                  はじめまして。呉市焼山町出身で、現在は江田島市を拠点にエアコンクリーニングを行っています。
                </p>

                <p>
                  江田島商工会に加入し、一般社団法人 日本エアコンクリーニング協会の個人会員として、安全で適切な作業を心掛けています。
                </p>

                <p>
                  お客様のご自宅にお伺いする仕事だからこそ、作業内容だけでなく、清潔さにもこだわっています。作業時に使用する床養生マットや道具は、作業後に必ず自宅で洗浄・清掃し、次のお客様へ持ち越さないようにしています。
                </p>

                <p>
                  また、ご希望があれば女性スタッフの同行も可能です。一人暮らしの女性や、ご高齢の方のご自宅でも、安心してご利用いただけるよう配慮しています。
                </p>

                <p>
                  安心してお任せしていただけるよう、丁寧な作業と分かりやすい説明を心がけています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
